import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { State } from 'react-automata'
import Hammer from '../../components/Hammer'
import Item from '../../components/Item'
import ItemImage from '../../components/ItemImage'
import CharacterKeoniForwardImage from '../../assets/images/character--keoni-forward@3x.png'
import CharacterPluggyForwardImage from '../../assets/images/character--pluggy-forward@3x.png'
import RoomLiving from '../../components/RoomLiving'
import { media } from '../../theme'

const StyledHammer = styled(Hammer)`
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
`

const StyledRoomLiving = styled(RoomLiving).attrs({
  style: p => ({
    width: `${p.scale * 100}vmin`,
    transform: `translate3d(calc(-25% + ${p.x}px), calc(-50% + ${p.y}px), 0)`,
  }),
})`
  left: 50%;
  position: absolute;
  top: 50%;
`

const TipContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  left: 0;
  padding: ${p => p.theme.spacing(4)} ${p => p.theme.spacing(1)}
    ${p => p.theme.spacing(5)};
  pointer-events: none;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 4;
`

const TipBackground = styled.div`
  background-color: ${p => (p.block ? 'rgba(0, 0, 0, 0.6)' : 'transparent')};
  height: 100%;
  left: 0;
  pointer-events: ${p => (p.block ? 'auto' : 'none')};
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 1;
`

export default class LivingRoomRoomMobile extends Component {
  static propTypes = {
    pendingHighlightIds: PropTypes.arrayOf(PropTypes.string),
    successHighlightIds: PropTypes.arrayOf(PropTypes.string),
    onItemClick: PropTypes.func.isRequired,
    clickedAllItems: PropTypes.bool,
  }

  static defaultPropTypes = {
    clickedAllItems: false,
  }

  render() {
    const {
      animateIds,
      clickedAllItems,
      onItemClick,
      pendingHighlightIds,
      renderTip,
      shouldBlock,
      successHighlightIds,
      transition,
      onRoomClear,
      roomProgressData,
      buttonText,
    } = this.props

    return [
      <TipContainer key="living-room__room__tip-container--mobile">
        <State value="items">
          {clickedAllItems &&
            renderTip('living-room__conclusion', {
              character: 'keoni',
              closeButtonText: buttonText,
              closeType: 'button',
              onClose: event => onRoomClear(event, roomProgressData),
            })}
        </State>
        <State value="guide">{renderTip('living-room__guide--mobile')}</State>
        <State value="entertainmentSystem">
          {renderTip('living-room__entertainmentSystem')}
        </State>
        <State value="blinds">{renderTip('living-room__blinds')}</State>
        <State value="ac">{renderTip('living-room__ac')}</State>
        <State value="powerStrip">{renderTip('living-room__powerStrip')}</State>
        <State value="chloe">{renderTip('living-room__chloe')}</State>
      </TipContainer>,
      <TipBackground
        block={shouldBlock}
        onClick={() => transition('NEXT')}
        key="living-room__room__tip-background--mobile"
      />,
      <StyledHammer initialScale={1.5} key="living-room__room__hammer--mobile">
        {(x, y, scale) => (
          <StyledRoomLiving
            animateIds={animateIds}
            dropChildrenMotion={false}
            onItemClick={onItemClick}
            pendingHighlightIds={pendingHighlightIds}
            scale={scale}
            successHighlightIds={successHighlightIds}
            x={x}
            y={y}
          />
        )}
      </StyledHammer>,
    ]
  }
}



// WEBPACK FOOTER //
// ./src/pages/living-room/_LivingRoomRoom.mobile.js